module.exports = __webpack_public_path__ + "static/ch-him2-lp-hero-quiz-41c8461c6a8b2a7631ba49fa0c24498c.jpg";